import { ActionType, LogLevel, LogType } from '@/utils/logTypes';
import { TokenStatus } from '@/utils/tokenStatus';
import tokenHelper from '@/utils/tokenHelper';
import { LogFactory } from '@/logger';
import axios from 'axios';
import { bumpIdleActivity } from '@/utils/idle-logout';
import { readSessionToken } from '@/utils/session-token';

// Cache the last known token and its status to minimize storage access
let lastKnownToken = readSessionToken();
let tokenStatus = lastKnownToken
  ? tokenHelper.isTokenExpired(lastKnownToken)
    ? TokenStatus.EXPIRED
    : TokenStatus.STAY
  : TokenStatus.EMPTY;

axios.interceptors.request.use(
  (config) => {
    const currentToken = readSessionToken();

    if (currentToken) {
      bumpIdleActivity();
    }

    // Check if the token has changed or needs to be initialized
    if (currentToken !== lastKnownToken) {
      lastKnownToken = currentToken;

      const currentStatus = currentToken
        ? tokenHelper.isTokenExpired(currentToken)
          ? TokenStatus.EXPIRED
          : TokenStatus.STAY
        : TokenStatus.EMPTY;

      // Log and update status only if it changes to expired
      if (
        tokenStatus !== currentStatus &&
        currentStatus === TokenStatus.EXPIRED
      ) {
        logger.loggingTokenExpired(currentToken);
      }

      tokenStatus = currentStatus;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

const logTokenEvent = (
  description: string,
  token: string | null,
  action: ActionType,
) => {
  const level = LogLevel.INFO;
  const type = LogType.TOKEN;
  const logData = LogFactory.getLogFormatData(level, type, {
    data: { type: description, token },
  });
  LogFactory.log(level, logData, action);
};

const logger = {
  loggingTokenExpired(token: string | null) {
    logTokenEvent('token expired', token, ActionType.SESSION_EXPIRED);
  },
  loggingNewToken(token: string | null) {
    logTokenEvent('new token', token, ActionType.NEW_SESSION);
  },
};

export default logger;
